import { Message } from '../../components/chat/types';
import { MESSAGE_TYPES, MAX_AUDIO_RESPONSE_LENGTH } from './constants';
import { lerTextoEmVoz } from '../../util/voice';

export const formatTime = (): string => {
  return new Date().toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const extractMarkdownLink = (text: string): string | null => {
  const match = text.match(/\[(.*?)\]\((https?:\/\/[^\s)]+)\)/);
  return match ? match[2] : null;
};

export const createErrorMessage = (): Message => ({
  from: MESSAGE_TYPES.LIA,
  text: 'Desculpe, ocorreu um erro ao processar sua mensagem. Por favor, tente novamente.',
  time: formatTime(),
  type: MESSAGE_TYPES.TEXT,
});

export const handleAudioResponse = (response: string): void => {
  if (response.length > MAX_AUDIO_RESPONSE_LENGTH) {
    const firstSentence = response.split('.')[0];
    const hasLink = extractMarkdownLink(response);
    const message = `${firstSentence}${hasLink ? '.  Click no link para mais informações.' : ''}`;
    lerTextoEmVoz(message);
    return;
  }
  lerTextoEmVoz(response);
};

export const createLiaMessage = (response: string): Message => ({
  from: MESSAGE_TYPES.LIA,
  text: response.toString(),
  time: formatTime(),
  type: MESSAGE_TYPES.TEXT,
}); 

export const createLiaAudioMessage = ({
  text,
  audioUrl,
}: {
  text: string;
  audioUrl: string | null;
}): Message => ({
  from: MESSAGE_TYPES.LIA,
  text: text,
  time: formatTime(),
  type: MESSAGE_TYPES.AUDIO,
  audioUrl: audioUrl || undefined,
});